"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionStore = void 0;
var tslib_1 = require("tslib");
var engine = tslib_1.__importStar(require("store/src/store-engine"));
var sessionStorage = tslib_1.__importStar(require("store/storages/sessionStorage"));
var memoryStorage = tslib_1.__importStar(require("store/storages/memoryStorage"));
exports.sessionStore = engine.createStore([sessionStorage, memoryStorage]);
